'use client';

import { useCallback, useSyncExternalStore } from 'react';

const lists = new Map<string, MediaQueryList>();

function list(query: string): MediaQueryList {
  let entry = lists.get(query);
  if (!entry) {
    entry = window.matchMedia(query);
    lists.set(query, entry);
  }
  return entry;
}

/** `matchMedia` as an external store: false on the server, live in the browser. */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback((onChange: () => void) => {
    const entry = list(query);
    entry.addEventListener('change', onChange);
    return () => entry.removeEventListener('change', onChange);
  }, [query]);
  return useSyncExternalStore(subscribe, () => list(query).matches, () => false);
}
